/*! Digital Turn — ShopElmore custom bridge • Premium PDP v1 • 13 Sep 2026 */
(function(){
  'use strict';
  if (window.__DT_CUSTOM_BRIDGE_PDP_PREMIUM_V1__) return;
  window.__DT_CUSTOM_BRIDGE_PDP_PREMIUM_V1__ = true;

  var current = document.currentScript;
  var src = current && current.src ? current.src : '';

  function assetUrl(filename){
    if (!src) return '';
    try {
      var url = new URL(filename, src);
      url.search = '';
      url.searchParams.set('dtv','20260913-pdp-premium-v1');
      return url.href;
    } catch(e){
      return src.replace(/custom\.js(?:\?.*)?$/, filename + '?dtv=20260913-pdp-premium-v1');
    }
  }

  function loadCss(filename, marker){
    var href = assetUrl(filename);
    if (!href || document.querySelector('link[' + marker + ']')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute(marker,'1');
    document.head.appendChild(link);
  }

  function loadScript(filename, marker){
    var url = assetUrl(filename);
    if (!url || document.querySelector('script[' + marker + ']')) return;
    var script = document.createElement('script');
    script.src = url;
    script.async = false;
    script.setAttribute(marker,'1');
    document.head.appendChild(script);
  }

  loadCss('dt-native-pro-ux.css','data-dt-native-pro-ux-css');
  loadCss('dt-shopelmore-layout-v2.css','data-dt-shopelmore-layout-v2-css');
  loadCss('dt-shopelmore-pdp-premium.css','data-dt-shopelmore-pdp-premium-css');

  loadScript('dt-custom-core-safe12sep-before-nativeux-20260913.js','data-dt-custom-core');
  loadScript('dt-native-pro-ux.js','data-dt-native-pro-ux');
  loadScript('dt-shopelmore-pdp-premium.js','data-dt-shopelmore-pdp-premium-js');
})();
